import React, { useState } from "react";
import Content from "../../../layout/content/Content";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useEffect } from "react";
import { regions } from "../../data/country";
import {
  Block,
  Button,
  DocumentScan,
  Icon,
  Input,
  InputRadio,
  Loading,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import DocRadio2 from "../../../components/input/radio/DocRadio2";
import CountrySelect2 from "../../../components/input/select/Country2";
import { apiRequest } from "../../../utils/Api";
import RSelect2 from "../../../components/select/ReactSelect2";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";

const KycDocuments = ({ number, disabled, ...props }) => {

  // console.log(countryList().getValue('CA'))
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);
  const request_id = queryParameters.get("request_id");
  const [step, setStep] = useState();
  const [tabSelection, setTabSelection] = useState("passport");
  const [loading, setLoading] = useState(true);
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
  const [disabledTab, setdisabledTab] = useState({
    passport: false,
    card: false,
    drivers: false,
    credit: false,
  });
  const [modal, setModal] = useState()

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    setValue,
    watch,
  } = useForm();

  const [load, setLoad] = useState(0);
  if (load < 1) {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setLoad(2);
  }


  const toggleModal = () => {
    setModal(!modal)
  }

  useEffect(() => {
    checkStep();
    // const doctype = localStorage.getItem("document1");
    // const position = JSON.parse(localStorage.getItem("at_position")).step;
    // setValue('request_id',JSON.parse(localStorage.getItem("at_requestor")).id)
    // if (position) {
    //     const step = JSON.parse(localStorage.getItem("at_position")).step;
    //     console.log(step);
    //     props.jump(position);
    // }
    // if(position === 1){
    //   setTabSelection('passport')
    // }
    // if (position > 1) {
    //   setdisabledTab({ ...disabledTab, [doctype]: true });
    //   if (doctype === "passport") {
    //     setTabSelection("card");
    //   } else {
    //     setTabSelection("passport");
    //   }
    window.scrollTo(0, 0, 'smooth');
    // }
  }, []);

  const checkStep = async () => {
    await apiRequest(`/ccr/verify/step/check/${props.request_id}`).then((resp) => {
      if (resp) {

        console.log(resp);
        console.log(resp.data.step)
        if (resp.code === 401) {
          navigate("/errors/401-classic", { state: { message: resp.message } });
        } else if (resp.code === 200) {
          // console.log(resp.data.step);
          setStep(resp.data.step);
          console.log(step)
          if (resp.data.step === 0) {
            // console.log("step 0");
            navigate("/ccr/kyc?request_id=" + request_id);
          } else if (resp.data.step === 4) {
            console.log('disabel')
            setdisabledTab({ ...disabledTab, [resp.data.doctype]: true });
            console.log(disabledTab)
            if (resp.data.doctype === "passport") {
              setTabSelection("card");
            } else if (resp.data.doctype === "card") {
              setTabSelection("passport");
            } else {
              setTabSelection("passport");
            }
          } else {
          }
        }
      }

      setLoading(false);
    });
  };
  const docButText = {
    passport: {
      first: "Cover of Passport",
      second: "Data Page of Passport",
    },
    card: {
      first: "Front of ID Card",
      second: "Back of ID Card",
    },
    drivers: {
      first: "Front of Driver's Licence",
      second: "Back of Driver's Licence",
    },
    credit: {
      first: "Front of Credit Card",
      second: "Back of Credit Card",
      third: "",
    },
  };

  const changeTab = (name) => {
    if (name === "credit") {
      setValue("creditCard", "credit");
      setValue("add-doc", "utility");
    } else {
      setValue("creditCard", "");
      setValue("add-doc", "");
    }
    setTabSelection(name);
  };

  const locationAccess = async () => {
    return new Promise((resolve, reject) => {
      const options = {
        enableHighAccuracy: true, // Request high accuracy (GPS)
        timeout: 10000, // Set a timeout of 10 seconds
        maximumAge: 0, // Ensure the result is not a cached position
      };

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // setValue("location", { latitude, longitude });
          resolve({ latitude, longitude });
        },
        (err) => {
          // Handle error
          console.log(err);
          resolve({ latitude: null, longitude: null });
        },
        options,
      );
    });
  };

  const onFormSubmit = async (e) => {
    // setLoading(true);
    setSubmitButtonLoading(true);
    // console.log(getValues());

    var data = new FormData();

    if (getValues("document1") && getValues("document1")[0]) {
      if (tabSelection === "passport") {
        data.append("passport_front", getValues("document2")[0]);
        data.append("passport_back", getValues("document1")[0]);
      }
      if (tabSelection === "card") {
        data.append("card_front", getValues("document1")[0]);
        data.append("card_back", getValues("document2")[0]);
      }
      if (tabSelection === "drivers") {
        data.append("drivers_front", getValues("document1")[0]);
        data.append("drivers_back", getValues("document2")[0]);
      }
      if (tabSelection === "credit") {
        data.append("credit_front", getValues("document1")[0]);
        data.append("credit_back", getValues("document2")[0]);
        data.append(`add_doc_${getValues("creditCard") === 'credit' ? 'bank_statement' : 'utility_bill'}`, getValues("document3")[0]);
      }
    }
    getValues("country") ? data.append("issue_country", getValues("country")) : data.append("issue_country", "");
    getValues("region") && (tabSelection !== "passport" || tabSelection !== "credit")
      ? data.append("issue_region", getValues("region"))
      : data.append("issue_region", "");
    data.append("request_id", getValues("request_id"));
    data.append("type", tabSelection);
    const location = await locationAccess();
    data.append("latitude", location.latitude || null);
    data.append("longitude", location.longitude || null);
    console.log(data)
    // const step = await JSON.parse(localStorage.getItem('at_position')).step
    try {
      await apiRequest(`/ccr/verify/step/${step}`, "POST", data, "file").then((resp) => {
        if (resp) {

          resp = JSON.parse(resp);
          console.log(resp)
          if (resp.code === 200) {
            props.jump(resp.data.step);

            // setLoading(false)

          } else if (resp.code === 450) {
            toggleModal()
            setValue('document1', null)
            setValue('document2', null)
            setSubmitButtonLoading(false);
          } else {
            setSubmitButtonLoading(false);
            setValue('document1', null)
            setValue('document2', null)
            console.log("error response: ", resp.message);
            toast.error(resp.message, {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
        }

      });
    } catch (err) {
      console.log(err);
      toast.error("Something went wrong", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setSubmitButtonLoading(false);
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    console.log('missing');

    await handleSubmit(onFormSubmit)();
    if (Object.keys(errors).length) {
      toast.error('missing information', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const onselect = (name, value) => {
    if (name === "country") {
      setValue("region", "");
    }
    if (getValues(name)) {
      delete errors[name];
    }
  };

  return (
    <React.Fragment>
      {loading && <Loading />}
      {!loading && tabSelection && (
        <Content>
          <Block className={submitButtonLoading && "disabled"}>
            <h5>Document {props.doc ? props.doc : "1"} of 2</h5>
            <p>Please select your first form of ID.</p>
            <form className="is-alter" onSubmit={handleFormSubmit}>
              <div className="form-group">
                <div className="form-control-wrap">
                  <div>
                    <ul className=" g-3 mb-2">
                      <DocRadio2
                        disabled={disabledTab.passport}
                        // onclick={() => setTabSelection("passport")}
                        onclick={() => changeTab("passport")}
                        label="Passport"
                        id="passport"
                        checked={tabSelection === "passport"}
                        name="doctype"
                        data="M27.14,23.73A15.55,15.55,0,1,0,42.57,39.4v-.12A15.5,15.5,0,0,0,27.14,23.73Zm11.42,9.72H33a25.55,25.55,0,0,0-2.21-6.53A12.89,12.89,0,0,1,38.56,33.45ZM31,39.28a26.9929,26.9929,0,0,1-.2,3.24H23.49a26.0021,26.0021,0,0,1,0-6.48H30.8A29.3354,29.3354,0,0,1,31,39.28ZM26.77,26.36h.75a21.7394,21.7394,0,0,1,2.85,7.09H23.91A21.7583,21.7583,0,0,1,26.77,26.36Zm-3.28.56a25.1381,25.1381,0,0,0-2.2,6.53H15.72a12.88,12.88,0,0,1,7.78-6.53ZM14.28,39.28A13.2013,13.2013,0,0,1,14.74,36H20.9a29.25,29.25,0,0,0,0,6.48H14.74A13.1271,13.1271,0,0,1,14.28,39.28Zm1.44,5.83h5.57a25.9082,25.9082,0,0,0,2.2,6.53A12.89,12.89,0,0,1,15.72,45.11ZM27.51,52.2h-.74a21.7372,21.7372,0,0,1-2.85-7.09h6.44A21.52,21.52,0,0,1,27.51,52.2Zm3.28-.56A25.1413,25.1413,0,0,0,33,45.11h5.57a12.84,12.84,0,0,1-7.77,6.53Zm2.59-9.12a28.4606,28.4606,0,0,0,0-6.48h6.15a11.7,11.7,0,0,1,0,6.48ZM14.29,62.6H40v2.6H14.28V62.61ZM56.57,49l1.33-5,2.48.67-1.33,5Zm-6,22.52L55.24,54l2.48.67L53.06,72.14Zm21.6-61.24-29.8-8a5.13,5.13,0,0,0-6.29,3.61h0L33.39,16H6.57A2.58,2.58,0,0,0,4,18.55V70.38A2.57,2.57,0,0,0,6.52,73L6.57,73h29.7l17.95,4.85a5.12,5.12,0,0,0,6.28-3.6v-.06L75.8,16.61a5.18,5.18,0,0,0-3.6066-6.3763L72.18,10.23ZM6.57,70.38V18.55H45.14a2.57,2.57,0,0,1,2.57,2.57V67.79a2.57,2.57,0,0,1-2.55,2.59H6.57ZM73.34,15.91,58,73.48a2.59,2.59,0,0,1-2.48,1.93,2.5192,2.5192,0,0,1-.67-.09l-9-2.42a5.15,5.15,0,0,0,4.37-5.11V47.24l1.32.36,1.33-5-2.49-.67-.16.62V21.94l2.62.71,3.05,10,2.13.57L57.88,24l3.76,1,1.65,3,1.42.39-.25-4.09,2.24-3.42-1.41-.39L62.4,22.15l-3.76-1,4.76-7.92-2.13-.57-7.6,7.14-4-1.08A5.1,5.1,0,0,0,45.14,16H36.05l2.51-9.45a2.57,2.57,0,0,1,3.12-1.84h0l29.81,8.05a2.56,2.56,0,0,1,1.56,1.21A2.65,2.65,0,0,1,73.34,15.91ZM56.57,39.59l.66-2.5,2.44.65L59,40.24Zm4.88,1.31.66-2.51,2.44.66-.65,2.5Zm-9.76-2.61.66-2.51,2.45.66-.66,2.5Z"
                        view="0 0 71.9904 75.9285"
                        trans="translate(-3.9995 -2.101)"
                        value="passport"
                      ></DocRadio2>
                      <DocRadio2
                        disabled={disabledTab.card}
                        onclick={() => changeTab("card")}
                        // onclick={() => setTabSelection("card")}
                        label="Photo ID Card"
                        id="card"
                        checked={tabSelection === "card"}
                        name="doctype"
                        data="M76,18.79,56.53,9.56a6.19,6.19,0,0,0-5.19,0l-19.5,9.23a3.35,3.35,0,0,0-1.9,2.55H8.33A6.26,6.26,0,0,0,2,27.51v38.3A6.27,6.27,0,0,0,8.33,72H71.67A6.27,6.27,0,0,0,78,65.81v-44A3.37,3.37,0,0,0,76,18.79Zm-.56,47a3.77,3.77,0,0,1-3.8,3.71H8.33a3.77,3.77,0,0,1-3.8-3.71V27.51a3.75,3.75,0,0,1,3.7993-3.7H29.87v9.34A34.49,34.49,0,0,0,44,60.41l7.51,5.8a4.11,4.11,0,0,0,4.94,0l7.51-5.8A36.5307,36.5307,0,0,0,75.47,45.62V65.81Zm0-32.66a32.09,32.09,0,0,1-13.1,25.34l-7.51,5.8a1.5,1.5,0,0,1-1.8,0l-7.51-5.8A32.05,32.05,0,0,1,32.4,33.15V21.83A.91.91,0,0,1,33,21l19.5-9.23a3.51,3.51,0,0,1,3,0L74.92,21a.91.91,0,0,1,.55.82V33.15ZM53.87,21.43a12.47,12.47,0,0,0-12.6,12.31,12.62,12.62,0,0,0,25.23,0,12.46,12.46,0,0,0-12.6178-12.3l-.0122,0Zm0,22.14A9.83,9.83,0,1,1,64,33.78a10,10,0,0,1-10.1,9.79Zm3.31-13.22-5.32,5.19-1.18-1.15a1.29,1.29,0,0,0-1.79,0,1.2,1.2,0,0,0-.013,1.697l.013.013h0l2.08,2a1.27,1.27,0,0,0,1.79,0L59,32.09a1.22,1.22,0,0,0,0-1.72h0a1.29,1.29,0,0,0-1.8,0ZM29.87,57.16h-20a1.24,1.24,0,1,0,0,2.47h20a1.24,1.24,0,0,0,0-2.47ZM19.73,62.1H9.89a1.24,1.24,0,0,0,0,2.48h9.84a1.24,1.24,0,0,0,0-2.48Zm8.66-14.28h0L24,45.71a.36.36,0,0,1-.22-.34V44.16a1.878,1.878,0,0,1,.18-.24,10.9991,10.9991,0,0,0,1.35-2.48,2.53,2.53,0,0,0,1.23-2.16V37.51a2.61,2.61,0,0,0-.46-1.43V34a4.69,4.69,0,0,0-1.15-3.43,6.68,6.68,0,0,0-5.19-1.85,6.67,6.67,0,0,0-5.18,1.85A4.61,4.61,0,0,0,13.4,34v2a2.46,2.46,0,0,0-.46,1.43v1.78a2.49,2.49,0,0,0,.78,1.81,10.148,10.148,0,0,0,1.52,3v1.2a.36.36,0,0,1-.21.33l-4.1,2.15A4.79,4.79,0,0,0,8.33,52v1.43a1.26,1.26,0,0,0,.37.88,1.33,1.33,0,0,0,.9.36H29.87a1.31,1.31,0,0,0,.9-.36,1.26,1.26,0,0,0,.37-.88V52.11A4.76,4.76,0,0,0,28.39,47.82Zm.21,4.4H10.87V52a2.27,2.27,0,0,1,1.25-2l4.12-2.16a2.85,2.85,0,0,0,1.54-2.5V43.72a1.3,1.3,0,0,0-.3-.8,7.39,7.39,0,0,1-1.4-2.8,1.53,1.53,0,0,0-.6-.83V37.46a1.22,1.22,0,0,0,.43-.92v-2.7a2.17,2.17,0,0,1,.53-1.58,4.38,4.38,0,0,1,3.28-1,4.43,4.43,0,0,1,3.26,1,2.22,2.22,0,0,1,.55,1.6.8552.8552,0,0,0,0,.16v2.56a1.36,1.36,0,0,0,.46,1l-.08,1.86a1.23,1.23,0,0,0-.84.8,8.5819,8.5819,0,0,1-1.19,2.31c-.1.14-.22.28-.33.41a1.22,1.22,0,0,0-.33.82v1.66A2.86,2.86,0,0,0,22.86,48l4.41,2a2.28,2.28,0,0,1,1.33,2.07v.15Z"
                        view="0 0 76 63"
                        trans="translate(-2 -8.9898)"
                        value="card"
                      ></DocRadio2>
                      <DocRadio2
                        disabled={disabledTab.drivers}
                        onclick={() => changeTab("drivers")}
                        // onclick={() => setTabSelection("drivers")}
                        label="Driver's Licence"
                        id="drivers"
                        checked={tabSelection === "drivers"}
                        name="doctype"
                        data="M70.5,2H9.9A7.9167,7.9167,0,0,0,2,9.9V51.5A7.49,7.49,0,0,0,9.5,59H31.6a1.538,1.538,0,0,0,1.5-1.5A1.4727,1.4727,0,0,0,31.6,56H9.7A4.6946,4.6946,0,0,1,5,51.3V15H75V46.9a1.5,1.5,0,1,0,3,0V10.1C78,5.6,74.7,2,70.5,2ZM75,11H5V9.5A4.6115,4.6115,0,0,1,9.8,5H70.3a4.6115,4.6115,0,0,1,4.8,4.5V11ZM64.3,29.5a4.1408,4.1408,0,0,1-1.5,2.9.9593.9593,0,0,0-.3,1L63,35a.9879.9879,0,0,0,.7.7l3.9,1a2.0749,2.0749,0,0,1,1,.6.972.972,0,0,0,1.4-.1h0a.9663.9663,0,0,0-.1-1.4h0a5.7028,5.7028,0,0,0-2.2-1.1l-3-.8-.1-.5a7.08,7.08,0,0,0,1.6-3.1,1.8059,1.8059,0,0,0,1-1.4l.2-1.7a1.8411,1.8411,0,0,0-.8-1.8l.1-1.1.2-.2a2.5846,2.5846,0,0,0,.1-3.4,4.3847,4.3847,0,0,0-3.8-1.8,7.2965,7.2965,0,0,0-3.5.9c-4.1.1-4.6,2.4-4.6,4,0,.3.1.9.1,1.5-.1.1-.3.2-.4.3a1.9638,1.9638,0,0,0-.5,1.5l.2,1.7a2.0944,2.0944,0,0,0,1.1,1.5,6.1046,6.1046,0,0,0,1.5,3l-.1.6-3,.8A5.4636,5.4636,0,0,0,49.9,40a.9448.9448,0,0,0,1,1H65a1,1,0,0,0,0-2H52.1a3.1116,3.1116,0,0,1,2.5-2.3l3.6-.9a.9879.9879,0,0,0,.7-.7l.4-1.7a.8065.8065,0,0,0-.3-.9,4.6858,4.6858,0,0,1-1.4-2.9.8949.8949,0,0,0-1-.8l-.3-1.6a.9448.9448,0,0,0,1-1v-.1a19.0913,19.0913,0,0,1-.2-2c0-1,0-2,2.9-2a1.4213,1.4213,0,0,0,.6-.2,4.1045,4.1045,0,0,1,2.6-.7,2.1984,2.1984,0,0,1,2.1.9c.4.6.2.8.1.9l-.4.2a.9078.9078,0,0,0-.3.7L64.6,26a.7787.7787,0,0,0,.7.9h.2l-.1,1.6A1.0278,1.0278,0,0,0,64.3,29.5ZM34.1,27a1.538,1.538,0,0,0,1.5-1.5A1.4727,1.4727,0,0,0,34.1,24h-6a1.5,1.5,0,0,0,0,3ZM12.8,37h21a1.5,1.5,0,0,0,0-3h-21a1.538,1.538,0,0,0-1.5,1.5A1.4727,1.4727,0,0,0,12.8,37Zm-.4-10h9a1.5,1.5,0,0,0,0-3h-9a1.5,1.5,0,1,0,0,3ZM74.9,55a2.0059,2.0059,0,0,0-2-2h-.2a7.0756,7.0756,0,0,0-3.1,1c-1.4-3-3.8-5.6-5.4-6.4-1.1-.6-4.9-1.2-8.3-1.2s-7.1.6-8.2,1.2c-1.7.8-4,3.4-5.4,6.4a6.6831,6.6831,0,0,0-3.1-1,2.2959,2.2959,0,0,0-1.4.4A2.0876,2.0876,0,0,0,37,55a5.5585,5.5585,0,0,0,2,4c.2.1.3.2.5.3a16.4687,16.4687,0,0,0-1,5.8c0,2.1.2,5.8,1.5,7.7v2.4a2.9483,2.9483,0,0,0,2.8,2.9h3.4A2.8616,2.8616,0,0,0,49,75.3h0v-1a27.5212,27.5212,0,0,0,7,1,27.5212,27.5212,0,0,0,7-1v1a2.7754,2.7754,0,0,0,2.7,2.8H69a2.8183,2.8183,0,0,0,2.9-2.8h0V72.9c1.2-1.9,1.4-5.5,1.4-7.7a16.0869,16.0869,0,0,0-1-5.8.8643.8643,0,0,0,.6-.3A5.7634,5.7634,0,0,0,74.9,55ZM49.3,50.1a22.2387,22.2387,0,0,1,6.8-.8,30.84,30.84,0,0,1,6.8.8c1.1.5,3.6,3.4,4.6,6.5-2.7.4-9.1,1.2-11.5,1.2s-8.7-.9-11.4-1.2C45.7,53.5,48.2,50.7,49.3,50.1Zm-8.1,6.6c-.1-.2-.3-.3-.4-.5a2.1859,2.1859,0,0,1,.5.3c0,.1,0,.1-.1.2ZM46.1,75H43V74h3v1.1Zm23,0H66V74h3v1.1Zm.4-5H66.9a6.7381,6.7381,0,0,0-2.6.9h0a32.0084,32.0084,0,0,1-8.2,1.4,42.62,42.62,0,0,1-7.6-1.5,6.1538,6.1538,0,0,0-1.9-.2l-4,.4a19.5493,19.5493,0,0,1-.8-5.9,6.15,6.15,0,0,1,.1-1.4c1.9.1,4.2.7,4.2,1.4a1.52,1.52,0,0,0,1.4,1.5h0c.8,0,1.5-1.4,1.5-1.4v-.7c0-3.4-4.7-4-6.5-4.1.2-.5.4-1,.6-1.4h0c.4.1,9.8,1.4,13,1.4S68.7,59.1,69,59h0c.2.5.4.9.6,1.4-1.8.1-6.4.7-6.4,4.1a1.4036,1.4036,0,0,0,2.8,0v-.1c0-.7,2.2-1.3,4.2-1.4a6.602,6.602,0,0,1,.1,1.4A17.2549,17.2549,0,0,1,69.5,70Zm1.6-13.3c0-.1-.1-.1-.1-.2l.5-.3A2.1813,2.1813,0,0,1,71.1,56.7ZM59.2,64h-6a1.5,1.5,0,0,0,0,3h6a1.5,1.5,0,0,0,0-3Z"
                        view="0 0 76 76"
                        trans="translate(-2 -2)"
                        value="drivers"
                      ></DocRadio2>
                      <DocRadio2
                        disabled={disabledTab.credit}
                        onclick={() => changeTab("credit")}
                        // onclick={() => setTabSelection("credit")}
                        label="Credit OR Debit Card"
                        id="credit"
                        checked={tabSelection === "credit"}
                        name="doctype"
                        data="M513.000000,335.531342   C511.507477,335.205414 511.396973,336.243896 510.979065,337.319977   C504.296875,354.526184 491.501373,363.159668 473.246704,363.986908   C466.266510,364.303284 466.000580,364.490387 466.000153,371.118561   C465.999207,385.281219 465.873657,399.445312 466.030304,413.606232   C466.250488,433.509735 450.412598,451.794220 430.207153,453.221466   C423.760559,453.676849 417.338867,453.955841 410.911652,453.958801   C288.779510,454.015137 166.647293,454.064728 44.515263,453.935272   C24.766970,453.914337 9.754193,445.893402 2.654847,426.286377   C2.508296,425.881653 1.916800,425.638031 1.266440,425.659637   C1.000000,342.979095 1.000000,259.958221 1.000000,176.468658   C2.312379,177.254883 2.633548,175.824783 2.876867,175.147293   C7.870118,161.243942 17.953159,153.188477 31.958704,149.456787   C33.801678,148.965729 35.569328,149.021652 37.366814,149.021332   C167.862610,148.998032 298.358429,148.997223 428.854218,149.003601   C445.207855,149.004395 462.438538,164.081055 465.084290,180.267746   C465.837891,184.878265 465.995880,189.438553 465.996582,194.050659   C466.002289,232.049438 465.967010,270.048279 466.042419,308.046906   C466.051575,312.647034 464.216278,315.891479 459.843475,316.851807   C455.832611,317.732697 452.447815,316.296234 450.556061,312.135468   C449.727936,310.314056 450.032471,308.554504 450.030640,306.783417   C449.990448,267.618042 449.795898,228.450928 450.123718,189.288269   C450.222717,177.457718 437.926514,164.741180 425.768066,164.775543   C297.439911,165.138458 169.110199,165.069443 40.781281,164.878479   C29.614819,164.861862 17.206919,174.846420 16.710791,186.761292   C16.436646,193.345093 16.051712,199.962341 16.044594,206.556763   C15.971745,274.054504 15.961200,341.552399 16.036760,409.050171   C16.049925,420.808746 19.996729,430.602875 31.523958,435.778320   C34.963249,437.322479 38.676933,437.993134 42.463676,437.993347   C169.459595,438.001343 296.455536,438.044037 423.451355,437.940948   C438.359894,437.928864 450.324463,427.752197 450.086273,411.621216   C449.746735,388.626984 449.995728,365.623993 450.002808,342.624725   C450.004669,336.562561 453.084167,332.921997 458.090729,333.009674   C463.139557,333.098083 465.979584,336.621429 466.000397,342.819061   C466.005432,344.318787 466.004639,345.818756 466.031036,347.318176   C466.046722,348.207214 466.307129,348.797577 467.384430,348.979584   C478.835663,350.914154 494.531067,340.609985 496.752655,329.163147   C497.563721,324.984070 497.401550,320.478058 496.912598,316.209473   C495.126099,300.613007 492.892029,285.068085 491.063293,269.476013   C489.535187,256.447266 488.483246,243.362717 486.957214,230.333710   C485.130035,214.734131 482.933014,199.178101 481.069916,183.582443   C479.882843,173.645950 479.147888,163.655518 477.963959,153.718613   C476.455536,141.058289 474.450104,128.453247 473.140015,115.774651   C472.333313,107.967697 472.309479,100.045235 469.943695,92.503349   C466.561951,81.722801 454.997101,75.260956 443.760956,76.871552   C433.862000,78.290482 423.845245,78.866051 413.906006,80.031349   C400.908875,81.555161 387.946442,83.374435 374.950775,84.911697   C365.178955,86.067612 355.368439,86.894279 345.593201,88.023888   C335.519348,89.187996 325.474304,90.599815 315.403870,91.795166   C305.794159,92.935829 296.162170,93.888115 286.550507,95.013161   C276.152466,96.230255 265.772156,97.598755 255.373856,98.813400   C245.764313,99.935921 236.134949,100.888992 226.525711,102.014099   C216.125824,103.231773 205.763428,104.844337 195.337952,105.742210   C188.624588,106.320374 181.969666,107.250488 175.287445,108.008659   C164.882095,109.189262 154.492737,110.580177 144.094330,111.720497   C134.156494,112.810310 124.221077,114.006279 114.273270,115.045059   C104.350136,116.081261 94.470474,117.527496 84.561775,118.710350   C77.563614,119.545746 70.564308,120.489792 63.536995,120.928818   C56.751957,121.352707 51.340687,124.421745 46.710594,128.922989   C42.726166,132.796524 38.568478,133.699127 34.495266,130.775299   C31.355947,128.521835 30.908916,123.498672 33.960098,119.362839   C40.696167,110.232201 50.336006,106.366005 61.225586,105.003441   C71.777710,103.683098 82.304306,102.034309 92.894569,101.180031   C102.389740,100.414093 111.800224,99.088341 121.244156,97.983055   C131.806564,96.746864 142.324173,95.012886 152.914902,94.167824   C162.574875,93.397034 172.150742,92.049225 181.763748,90.968918   C192.162918,89.800247 202.524918,88.302658 212.921432,87.107803   C222.862106,85.965355 232.836105,85.113327 242.777390,83.975708   C252.692047,82.841141 262.579712,81.472679 272.487854,80.278893   C279.319153,79.455826 286.170319,78.798279 293.003601,77.990540   C303.566772,76.741875 314.117584,75.388367 324.682343,74.153687   C334.124268,73.050255 343.583282,72.092819 353.025055,70.988152   C363.592224,69.751808 374.122345,68.093781 384.718872,67.250587   C391.605530,66.702591 398.417603,65.691536 405.268768,64.954910   C415.347443,63.871258 425.429199,62.715679 435.445740,61.175224   C457.762421,57.743130 479.174164,65.340981 486.411407,91.146049   C488.203369,97.535477 488.168854,104.434547 489.003876,111.095581   C490.285889,121.322235 491.672485,131.536453 492.868195,141.773056   C494.009674,151.545258 494.751007,161.367889 496.058685,171.115952   C497.428406,181.326065 498.108582,191.605453 499.774902,201.795349   C501.360260,211.490097 501.781738,221.369064 503.050293,231.123413   C504.379730,241.345718 505.167145,251.623108 506.782166,261.824585   C508.345245,271.697845 508.822021,281.738373 510.066711,291.668976   C510.604614,295.960510 510.096893,300.470947 512.620728,304.250671   C513.000000,314.354218 513.000000,324.708466 513.000000,335.531342  z M145.000122,290.879700   C146.140533,306.364044 133.568771,317.819000 119.494598,317.162231   C104.207008,316.448822 88.840889,316.520386 73.545235,317.141663   C59.561615,317.709686 47.729851,305.010681 48.799824,292.577179   C49.752937,281.501617 49.309734,270.268127 48.911232,259.124786   C48.527470,248.393509 59.176888,237.221558 70.931122,237.059982   C87.914108,236.826523 104.903412,236.904358 121.888641,237.032471   C134.124741,237.124741 144.713455,247.883591 144.957611,259.922821   C145.163528,270.077087 145.000076,280.238831 145.000122,290.879700  z M113.000000,396.999847   C94.187279,396.999817 75.874252,396.943359 57.562046,397.040466   C53.126713,397.063995 49.670063,396.136261 49.017746,391.056335   C48.315601,385.588348 50.082680,383.397186 55.702755,381.612213   C57.199818,381.136719 58.591633,381.018402 60.041653,381.017761   C111.317276,380.994873 162.592896,380.990082 213.868530,381.008179   C221.317474,381.010803 224.864502,383.651398 224.998856,389.099518   C225.138245,394.751160 222.886566,396.988007 216.883667,396.991882   C189.581055,397.009521 162.278458,396.999786 134.975845,396.999847   C127.817230,396.999878 120.658615,396.999847 113.000000,396.999847  z M385.999695,250.861450   C385.827271,239.177856 383.459076,228.480026 378.741791,218.264862   C375.095612,210.369049 378.560272,204.533615 386.342773,204.983017   C390.287231,205.210800 392.140717,208.059311 393.424713,211.011581   C398.871948,223.536392 402.230530,236.627274 401.928894,250.354416   C401.643616,263.338043 398.552094,275.788208 393.047089,287.575714   C390.711517,292.576660 386.356689,294.321564 381.834045,292.350830   C377.405243,290.420990 375.707458,286.532257 378.131073,281.335327   C382.595398,271.762421 384.989777,261.752319 385.999695,250.861450  z M125.868385,343.011475   C128.979813,346.807709 130.492935,350.549866 126.893990,354.611481   C125.516808,356.165710 124.054039,357.062531 121.784096,357.053162   C99.974327,356.963135 78.163979,356.976654 56.353924,357.020081   C52.340443,357.028076 49.715847,355.404907 49.037754,351.346100   C48.126431,345.891266 49.600224,343.686981 54.316807,341.784180   C56.126553,341.054108 57.822472,341.015411 59.603222,341.013397   C79.248978,340.991089 98.894852,341.028229 118.540428,340.964325   C121.101273,340.955994 123.450150,341.235168 125.868385,343.011475  zM146.730118,343.803986   C150.278046,341.253510 153.915176,340.924255 157.794449,340.947388   C176.918900,341.061523 196.044449,340.973022 215.169479,341.013489   C222.018188,341.027985 225.100220,343.846130 224.999435,349.752411   C224.932205,353.691956 221.887634,356.968109 217.968811,356.976562   C196.016586,357.023926 174.064072,357.046844 152.112030,356.968384   C146.089981,356.946869 143.470810,350.810577 146.730118,343.803986  z M348.307373,340.999664   C368.716919,340.999664 388.662079,341.034027 408.606964,340.973145   C412.977112,340.959808 415.617615,343.223053 417.385986,346.878876   C419.016113,350.248840 417.435028,352.767731 415.278748,355.296753   C413.735565,357.106689 411.885864,357.010101 409.894592,357.008759   C388.952271,356.994446 368.009949,357.002319 347.067627,356.998505   C340.557098,356.997345 338.396362,355.467987 338.003387,350.617035   C337.522369,344.678650 339.570740,342.158661 345.851257,341.027344   C346.495880,340.911224 347.178101,341.003967 348.307373,340.999664  z M258.026794,357.000000   C255.035934,356.999969 252.530197,356.859070 250.045486,357.027771   C243.892746,357.445496 241.428589,353.709381 241.089371,348.940430   C240.811798,345.038574 245.583084,341.064423 250.211914,341.019592   C257.699707,340.947021 265.188751,340.999329 272.677246,340.999359   C285.657318,340.999420 298.637756,340.943817 311.617340,341.023956   C317.998962,341.063354 321.015076,343.771851 320.999786,349.069275   C320.982819,354.945343 318.957825,356.983368 312.937958,356.991302   C294.799164,357.015167 276.660309,356.999969 258.026794,357.000000  z M366.020325,268.880432   C365.628540,270.022583 365.263763,270.753998 365.003143,271.520844   C362.974548,277.489899 358.696808,279.929413 353.600281,278.001709   C348.834900,276.199249 347.307068,271.618683 349.594086,265.865570   C351.032959,262.245972 352.236816,258.602631 353.117798,254.762543   C354.948608,246.782211 352.592590,239.624420 349.809814,232.465759   C347.186005,225.716049 348.690643,221.583160 354.651123,219.733551   C358.607422,218.505859 362.423889,220.376953 364.328308,224.834015   C369.730316,237.476562 371.630066,250.477463 367.485046,263.869720   C367.012604,265.396240 367.640930,267.296906 366.020325,268.880432  z M334.754944,237.426880   C337.790710,244.209503 338.233368,250.771698 335.994965,257.478088   C334.232330,262.758942 329.682831,265.416016 324.970642,263.909363   C320.830261,262.585480 318.985016,257.969635 320.657532,252.819794   C321.408569,250.507263 322.066895,248.262161 320.945068,245.896118   C318.795227,241.362000 319.565430,237.263702 323.914368,234.823364   C327.713287,232.691650 331.542358,233.796021 334.754944,237.426880  z M81.021942,279.478271   C80.998947,271.438843 83.374588,269.013245 90.876038,269.001343   C95.540482,268.993927 100.206299,268.929871 104.869026,269.019562   C109.786987,269.114136 113.055267,272.634735 112.996513,277.585724   C112.946609,281.790009 109.594170,284.899109 104.828255,284.980865   C99.998634,285.063782 95.161232,284.860138 90.337021,285.041748   C86.098183,285.201355 83.030319,283.612305 81.021942,279.478271  z"
                        view="0 0 512 512"
                        trans="translate(-2 -2)"
                        value="credit"
                      ></DocRadio2>
                    </ul>
                  </div>

                  <h6>
                    To avoid delays when verifying your documents, please make sure you follow the criteria below:
                  </h6>
                  <ul className="list list-sm list-checked">
                    <li>You must have the original document with you (no photocopies or images), in good condition, unexpired and authentic. </li>
                    {/* <li>Document should be in good condition, authentic, unexpired and an original.</li> */}
                    <li>All parts of the document must be unobstructed, visible and well lit with minimal glare.</li>
                    <li>
                      For Debit or Credit Cards, you will also be asked to scan a utility bill, bank statement, or credit card statement with your name and address on it, as well as the address associated with the chosen card.
                    </li>
                  </ul>

                  <Row>
                    {tabSelection !== "credit" && (
                      <Col>
                        <CountrySelect2
                          onselect={onselect}
                          setValue={setValue}
                          selectedCountry={watch("country")}
                          label="Country"
                          register={register}
                          requiredMessage="This field is required"
                          id="country"
                          name="country"
                          errors={errors}
                          placeholder="Select country"
                          className="form-control-lg p-0 border-0 form-control"
                        ></CountrySelect2>
                      </Col>
                    )}
                    <Col>
                      {(tabSelection === "drivers" || tabSelection === "card") &&
                        watch("country") !== "US" &&
                        watch("country") !== "CA" && (
                          <Input
                            errors={errors}
                            required
                            requiredMessage={{
                              required: "This field is required",
                              pattern: {
                                value: /^.{1,20}$/,
                                message: "Max 20 characters",
                              },
                            }}
                            register={register}
                            type="text"
                            label="Region"
                            id="region"
                            name="region"
                            className="form-control-lg form-control"
                          ></Input>
                        )}
                      {(tabSelection === "drivers" || tabSelection === "card") && watch("country") === "CA" && (
                        <RSelect2
                          setValue={setValue}
                          selectedCountry={watch("region")}
                          label="Region"
                          register={register}
                          requiredMessage="This field is required"
                          id="region"
                          name="region"
                          errors={errors}
                          onselect={onselect}
                          options={regions[watch("country")]}
                          placeholder="Select Region"
                          className="form-control-lg p-0 border-0 form-control"
                        />
                        // <RegionSelect
                        //   setValue={setValue}
                        //   selectedCountry={watch("country")}
                        //   label="Region"
                        //   register={register}
                        //   requiredMessage="This field is required"
                        //   required
                        //   id="region"
                        //   name="region"
                        //   errors={errors}
                        //   placeholder="Select Region"
                        //   className="form-control-lg p-0 border-0 form-control"
                        // ></RegionSelect>
                      )}
                      {(tabSelection === "drivers" || tabSelection === "card") && watch("country") === "US" && (
                        <RSelect2
                          onselect={onselect}
                          setValue={setValue}
                          selectedCountry={watch("region")}
                          label="Region"
                          register={register}
                          requiredMessage="This field is required"
                          id="region"
                          name="region"
                          errors={errors}
                          options={regions[watch("country")]}
                          placeholder="Select Region"
                          className="form-control-lg p-0 border-0 form-control"
                        />
                      )}
                    </Col>
                  </Row>
                  <div className="form-group">
                    {tabSelection === "credit" && (
                      <div>
                        <h6>Card Type</h6>
                        <p>Select type of card.</p>
                        <div className="form-group">
                          <div className="form-control-wrap">
                            {errors && errors.creditCard && <p className="invalid">{errors.creditCard.message}</p>}
                          </div>
                        </div>
                        <InputRadio
                          setValue={setValue}
                          label="Credit Card"
                          id="credit-card"
                          selectedValue={watch("creditCard")}
                          value="credit"
                          name="creditCard"
                          register={register}
                          // requiredMessage="This field is required"
                          className="form-control-lg p-0 border-0 form-control"
                        ></InputRadio>
                        <InputRadio
                          setValue={setValue}
                          // selectedValue={selectedValueCard}
                          label="Debit Card"
                          id="debit-card"
                          selectedValue={watch("creditCard")}
                          value="debit"
                          name="creditCard"
                          register={register}
                          // requiredMessage="This field is required"
                          className="form-control-lg p-0 border-0 form-control"
                        ></InputRadio>
                      </div>
                    )}
                    <DocumentScan
                      setValue={setValue}
                      value={watch("document1")}
                      requiredMessage="This field is required"
                      required
                      errors={errors}
                      capture="environment"
                      title={
                        tabSelection === "credit"
                          ? watch("creditCard") === "credit"
                            ? "Front of Credit Card"
                            : "Front of Debit Card"
                          : docButText[tabSelection].first
                      }
                      id="1"
                      register={register}
                      name="document1"
                      // onChange={setValue}
                      view="0 0 512 512"
                      trans="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                      pri="M152 4354 c-56 -28 -90 -63 -125 -128 l-22 -41 0 -1625 0 -1625 22 -41 c36 -67 70 -101 131 -131 l57 -28 2345 0 2345 0 57 28 c61 30 95 64 131 131 l22 41 0 1625 0 1625 -22 41 c-35 65 -69 100 -125 128 l-52 26 -2356 0 -2356 0 -52 -26z m4757 -139 c65 -33 61 79 61 -1655 0 -1741 5 -1620 -64 -1658 -29 -16 -183 -17 -2346 -17 -2280 0 -2315 0 -2347 20 -68 40 -63 -80 -63 1655 0 1721 -4 1614 58 1652 25 16 180 17 2350 18 2014 0 2327 -2 2351 -15z"
                      sec="M491 3963 c-18 -9 -45 -34 -60 -57 l-26 -40 0 -956 0 -956 27 -41 c14 -22 43 -48 65 -59 36 -18 70 -19 778 -19 708 0 742 1 778 19 22 11 51 37 65 59 l27 41 0 956 0 956 -27 41 c-51 77 -5 73 -845 73 -675 0 -751 -2 -782 -17z m1507 -748 l2 -610 -32 40 c-53 68 -145 152 -212 195 l-63 41 24 61 c70 172 21 384 -118 512 -33 31 -77 65 -98 75 -149 77 -344 69 -480 -18 -189 -121 -270 -367 -188 -569 l24 -61 -65 -43 c-69 -45 -157 -125 -210 -193 l-32 -40 0 606 c0 333 3 609 7 612 3 4 329 6 722 5 l716 -3 3 -610z m-569 180 c60 -33 109 -86 143 -154 32 -65 32 -195 -1 -262 -32 -68 -81 -120 -142 -154 -50 -28 -62 -30 -154 -30 -92 0 -104 2 -154 30 -245 136 -217 493 46 591 25 9 67 13 123 11 71 -2 94 -8 139 -32z m-423 -674 c166 -111 388 -109 544 3 l50 36 58 -36 c213 -136 327 -336 339 -598 6 -108 4 -120 -12 -133 -28 -19 -1392 -19 -1420 0 -16 13 -18 25 -12 133 10 220 87 387 242 525 30 27 136 103 151 108 1 1 28 -17 60 -38z M3461 1863 c-18 -9 -45 -34 -60 -57 l-26 -40 0 -256 0 -256 27 -41 c53 -80 33 -78 643 -78 610 0 590 -2 643 78 l27 41 0 256 0 256 -27 41 c-50 75 -28 73 -645 73 -489 0 -552 -2 -582 -17z m1107 -348 c2 -189 1 -211 -15 -222 -22 -17 -983 -19 -1014 -3 -18 10 -19 23 -19 219 0 114 3 211 7 214 3 4 239 6 522 5 l516 -3 3 -210z"
                      ter="M2557 3562 c-24 -27 -22 -85 4 -108 16 -15 36 -19 89 -19 83 0 110 18 110 75 0 56 -22 70 -112 70 -60 0 -78 -4 -91 -18z M3010 3560 c-43 -43 -14 -113 52 -125 18 -3 380 -5 804 -3 743 3 773 4 793 22 27 25 29 86 3 109 -17 16 -89 17 -825 17 -794 0 -807 0 -827 -20z M2557 3062 c-24 -27 -22 -85 4 -108 20 -18 52 -19 1049 -19 997 0 1029 1 1049 19 27 25 29 86 3 109 -17 16 -105 17 -1054 17 -990 0 -1036 -1 -1051 -18z M2557 2562 c-24 -27 -22 -85 4 -108 20 -18 52 -19 1049 -19 997 0 1029 1 1049 19 27 25 29 86 3 109 -17 16 -105 17 -1054 17 -990 0 -1036 -1 -1051 -18z M420 1258 c-23 -25 -26 -65 -6 -90 35 -46 140 -47 176 -1 25 33 25 54 -1 87 -18 23 -27 26 -84 26 -53 0 -68 -4 -85 -22z M860 1260 c-38 -38 -22 -100 31 -119 43 -15 1166 -15 1205 -1 55 21 71 78 34 118 l-21 22 -614 0 c-602 0 -615 0 -635 -20z"
                    />
                    <DocumentScan
                      value={watch("document2")}
                      requiredMessage="This field is required"
                      required
                      capture="environment"
                      errors={errors}
                      // title={docButText[tabSelection].second}
                      title={
                        tabSelection === "credit"
                          ? watch("creditCard") === "credit"
                            ? "Back of Credit Card"
                            : "Back of Debit Card"
                          : docButText[tabSelection].second
                      }
                      id="2"
                      register={register}
                      name="document2"
                      onChange={setValue}
                      view="0 0 512 512"
                      trans="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                      pri="M152 4354 c-56 -28 -90 -63 -125 -128 l-22 -41 0 -1625 0 -1625 22 -41 c36 -67 70 -101 131 -131 l57 -28 2345 0 2345 0 57 28 c61 30 95 64 131 131 l22 41 0 1625 0 1625 -22 41 c-35 65 -69 100 -125 128 l-52 26 -2356 0 -2356 0 -52 -26z m4757 -139 c65 -33 61 79 61 -1655 0 -1741 5 -1620 -64 -1658 -29 -16 -183 -17 -2346 -17 -2280 0 -2315 0 -2347 20 -68 40 -63 -80 -63 1655 0 1721 -4 1614 58 1652 25 16 180 17 2350 18 2014 0 2327 -2 2351 -15z"
                      sec="M3461 1863 c-18 -9 -45 -34 -60 -57 l-26 -40 0 -256 0 -256 27 -41 c53 -80 33 -78 643 -78 610 0 590 -2 643 78 l27 41 0 256 0 256 -27 41 c-50 75 -28 73 -645 73 -489 0 -552 -2 -582 -17z m1107 -348 c2 -189 1 -211 -15 -222 -22 -17 -983 -19 -1014 -3 -18 10 -19 23 -19 219 0 114 3 211 7 214 3 4 239 6 522 5 l516 -3 3 -210z"
                      ter="M420 3562 c-24 -27 -22 -85 4 -108 16 -15 36 -19 89 -19 83 0 110 18 110 75 0 56 -22 70 -112 70 -60 0 -78 -4 -91 -18z M1073 3560 c-43 -43 -14 -113 52 -125 18 -3 380 -5 804 -3 743 3 773 4 793 22 27 25 29 86 3 109 -17 16 -89 17 -825 17 -794 0 -807 0 -827 -20z M620 3062 c-24 -27 -22 -85 4 -108 20 -18 52 -19 1049 -19 997 0 1029 1 1049 19 27 25 29 86 3 109 -17 16 -105 17 -1054 17 -990 0 -1036 -1 -1051 -18z M620 2562 c-24 -27 -22 -85 4 -108 20 -18 52 -19 1049 -19 997 0 1029 1 1049 19 27 25 29 86 3 109 -17 16 -105 17 -1054 17 -990 0 -1036 -1 -1051 -18z M2557 3562 c-24 -27 -22 -85 4 -108 16 -15 36 -19 89 -19 83 0 110 18 110 75 0 56 -22 70 -112 70 -60 0 -78 -4 -91 -18z M3010 3560 c-43 -43 -14 -113 52 -125 18 -3 380 -5 804 -3 743 3 773 4 793 22 27 25 29 86 3 109 -17 16 -89 17 -825 17 -794 0 -807 0 -827 -20z M2557 3062 c-24 -27 -22 -85 4 -108 20 -18 52 -19 1049 -19 997 0 1029 1 1049 19 27 25 29 86 3 109 -17 16 -105 17 -1054 17 -990 0 -1036 -1 -1051 -18z M2557 2562 c-24 -27 -22 -85 4 -108 20 -18 52 -19 1049 -19 997 0 1029 1 1049 19 27 25 29 86 3 109 -17 16 -105 17 -1054 17 -990 0 -1036 -1 -1051 -18z M420 1258 c-23 -25 -26 -65 -6 -90 35 -46 140 -47 176 -1 25 33 25 54 -1 87 -18 23 -27 26 -84 26 -53 0 -68 -4 -85 -22z M860 1260 c-38 -38 -22 -100 31 -119 43 -15 1166 -15 1205 -1 55 21 71 78 34 118 l-21 22 -614 0 c-602 0 -615 0 -635 -20z"
                    />
                  </div>

                  {tabSelection === "credit" && (
                    <div className="">
                      <h6>Additonal Document</h6>
                      <p>You need to submit the following additional document</p>
                      {/* <InputRadio
                        setValue={setValue}
                        label="Utility Bill"
                        id="utility"
                        selectedValue={watch("add-doc")}
                        value="utility"
                        name="add-doc"
                        register={register}
                        // requiredMessage="This field is required"
                        className="form-control-lg p-0 border-0 form-control"
                      ></InputRadio>
                      <InputRadio
                        // setValue={setValue}
                        label="Bank Statement"
                        id="bank"
                        selectedValue={watch("add-doc")}
                        value="bank"
                        name="add-doc"
                        register={register}
                        // requiredMessage="This field is required"
                        className="form-control-lg p-0 border-0 form-control"
                      ></InputRadio> */}
                      <DocumentScan
                        value={watch("document3")}
                        requiredMessage="This field is required"
                        required
                        capture="environment"
                        errors={errors}
                        title={
                          tabSelection === "credit"
                            ? watch("creditCard") === "debit"
                              ? "Utility bill (with matching name and address) OR matching bank card statement (first page)"
                              : "Matching credit card statement (first page)"
                            : ""
                        }
                        id="document3"
                        register={register}
                        name={"document3"}
                        onChange={setValue}
                        view="0 0 512 512"
                        trans="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                        pri="M871 5104 c-205 -55 -369 -264 -416 -529 -13 -77 -15 -321 -15 -1951 l0 -1864 -142 0 c-188 -1 -234 -20 -273 -113 -20 -48 -19 -78 5 -173 61 -239 229 -423 423 -464 36 -7 535 -10 1657 -8 l1605 3 55 22 c170 70 300 232 363 451 l22 77 3 1903 2 1902 400 0 c423 0 442 2 494 48 26 23 56 91 56 128 0 55 -39 187 -82 274 -74 149 -201 258 -345 295 -85 22 -3729 21 -3812 -1z m3365 -145 c-78 -85 -131 -186 -169 -319 l-22 -75 -5 -2000 c-6 -2230 1 -2036 -75 -2190 -125 -257 -380 -328 -571 -161 -86 74 -154 207 -181 351 -18 98 -47 145 -105 174 l-44 21 -1252 0 -1252 0 2 1898 c3 1778 4 1901 21 1957 42 144 133 278 223 331 94 55 0 53 1798 53 l1668 1 -36 -41z m475 8 c70 -32 128 -83 175 -154 44 -66 89 -178 99 -245 6 -39 4 -49 -14 -67 -21 -21 -28 -21 -416 -21 l-396 0 6 38 c42 248 157 412 328 468 60 20 153 12 218 -19z m-1641 -4347 c11 -11 20 -32 20 -47 0 -97 79 -282 166 -386 l55 -67 -1423 2 -1423 3 -55 26 c-72 34 -129 85 -176 156 -44 66 -89 178 -99 245 -6 39 -4 49 14 67 l21 21 1440 0 c1427 0 1440 0 1460 -20z"
                        sec="M2900 4780 c-11 -11 -20 -29 -20 -40 0 -11 9 -29 20 -40 19 -19 33 -20 460 -20 427 0 441 1 460 20 11 11 20 29 20 40 0 11 -9 29 -20 40 -19 19 -33 20 -460 20 -427 0 -441 -1 -460 -20z M3220 4460 c-11 -11 -20 -29 -20 -40 0 -11 9 -29 20 -40 19 -19 33 -20 300 -20 267 0 281 1 300 20 11 11 20 29 20 40 0 11 -9 29 -20 40 -19 19 -33 20 -300 20 -267 0 -281 -1 -300 -20z M820 1340 c-11 -11 -20 -29 -20 -40 0 -11 9 -29 20 -40 19 -19 33 -20 300 -20 267 0 281 1 300 20 11 11 20 29 20 40 0 11 -9 29 -20 40 -19 19 -33 20 -300 20 -267 0 -281 -1 -300 -20z M820 1020 c-11 -11 -20 -29 -20 -40 0 -11 9 -29 20 -40 19 -19 33 -20 460 -20 427 0 441 1 460 20 25 25 25 55 0 80 -19 19 -33 20 -460 20 -427 0 -441 -1 -460 -20z"
                        ter="M2255 4079 c-52 -12 -1041 -532 -1079 -567 -48 -45 -56 -78 -56 -229 0 -113 4 -145 19 -179 21 -45 56 -77 107 -96 l34 -12 0 -408 c0 -380 -1 -409 -17 -414 -49 -15 -88 -42 -112 -78 -24 -36 -26 -50 -29 -162 -4 -144 11 -192 74 -240 l37 -29 1087 0 1087 0 37 29 c63 48 78 96 74 240 -3 112 -5 126 -29 162 -26 38 -47 54 -101 74 l-28 10 0 408 0 408 34 12 c51 19 86 51 107 96 15 34 19 66 19 179 0 155 -8 186 -61 232 -47 41 -1010 546 -1073 562 -56 15 -73 15 -131 2z m180 -150 c279 -143 925 -486 943 -502 21 -19 22 -28 22 -145 0 -103 -3 -129 -17 -144 -15 -17 -61 -18 -1061 -18 -959 0 -1047 1 -1064 17 -16 14 -18 33 -18 144 l0 128 33 24 c41 31 949 508 996 524 48 16 94 8 166 -28z m-795 -1339 l0 -410 -120 0 -120 0 0 410 0 410 120 0 120 0 0 -410z m440 0 l0 -410 -160 0 -160 0 0 410 0 410 160 0 160 0 0 -410z m360 0 l0 -410 -120 0 -120 0 0 410 0 410 120 0 120 0 0 -410z m440 0 l0 -410 -160 0 -160 0 0 410 0 410 160 0 160 0 0 -410z m360 0 l0 -410 -120 0 -120 0 0 410 0 410 120 0 120 0 0 -410z m140 -550 c17 -17 20 -33 20 -122 0 -80 -3 -105 -17 -120 -15 -17 -61 -18 -1061 -18 -959 0 -1047 1 -1064 17 -15 14 -18 32 -18 120 0 90 3 106 20 123 20 20 33 20 1060 20 1027 0 1040 0 1060 -20z M2268 3731 c-71 -23 -128 -100 -128 -172 1 -50 33 -112 76 -145 33 -25 46 -29 104 -29 58 0 71 4 104 29 43 33 75 95 76 145 0 50 -37 119 -79 147 -41 26 -111 38 -153 25z m92 -131 c24 -24 25 -48 4 -78 -31 -44 -104 -16 -104 40 0 24 35 58 60 58 11 0 29 -9 40 -20z"
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="mb-3">
                <div className=" nk-kycfm-note ">
                  <em className=" icon ni ni-info-fill"></em>
                  <p className="mb-5">
                    Once this document scan has been submitted, you can no longer return to this page.
                  </p>
                </div>
              </div>
              <div className="bg-primary" style={{ position: "fixed", bottom: "0px" }}>
                <div className="bg-white col-12" style={{ position: "fixed", bottom: "0px", right: "0px" }}>
                  <div style={{ margin: "10px 5px 10px 0px", float: "right" }} className="p-1">
                    {" "}
                    <Button color="primary" size="" className={submitButtonLoading && "disabled"} outline="">
                      {submitButtonLoading && <Spinner size="sm" />} Continue
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          </Block>
        </Content>
      )
      }
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader
          toggle={toggleModal}
          close={
            <button className="close" onClick={toggleModal}>
              <Icon name="cross" />
            </button>
          }
        >
          Error
        </ModalHeader>
        <ModalBody>

          <>
            <div>
              We cannot detect your document properly. Please ensure the following for a better result:
            </div>
            <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
              <li>Use a dark background.</li>
              <li>Ensure the image is not angled.</li>
              <li>Make sure the photo is clear and well-lit</li>
              <li>Avoid any reflections or glare on the document</li>
            </ul>
          </>


        </ModalBody>
      </Modal>
      <ToastContainer />
    </React.Fragment >
  );
};

export default KycDocuments;
